import { Component, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import * as fromInvoiceSetup from '../../../../data-services/invoice/setup';
import { SelectItem } from '../../../../shared';
import { LoggingService } from '../../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-selection-add',
    templateUrl: './invoice-selection-add.component.html',
    styleUrls: ['./invoice-selection-add.component.scss'],
    standalone: false
})
export class InvoiceSelectionAddComponent implements OnInit {
    @Input() addSelection: boolean;
    @Input() invoiceProperties: SelectItem[] = [];
    @Output() Cancel = new ReplaySubject();
    @Output() Save = new ReplaySubject();
    addSelectionFormGroup: UntypedFormGroup;
    @Input() public set item(
        value: fromInvoiceSetup.Selections.InvoiceSelections
    ) {
        this.log.verbose({
            type: 'InvoiceSelectionAddComponent:item:set',
            value
        });
        if (!!value) {
            this.addSelectionFormGroup.setValue({
                id: value.id || -1,
                Invoicepropertysharedid: value.Invoicepropertysharedid || -1,
                Invoicepropertyid: value.Invoicepropertyid || null,
                Propertylabel: value.Propertylabel || null,
                Propertytext: value.Propertytext || null
            });
        }
    }
    constructor(private log: LoggingService) {
        this.addSelectionFormGroup = new UntypedFormGroup({
            id: new UntypedFormControl(-1),
            Invoicepropertysharedid: new UntypedFormControl(-1),
            Invoicepropertyid: new UntypedFormControl(null),
            Propertylabel: new UntypedFormControl(null),
            Propertytext: new UntypedFormControl(null)
        });
    }

    ngOnInit(): void {}
}
